import { AppMode } from 'helpers/constants/enums';
import AbstractClientStore from './AbstractClientStore';

const LOCAL_STORAGE_APP_MODE_KEY = 'appMode';

class AppModeClientStore extends AbstractClientStore {
  static getAppMode(): string {
    const appMode = this.storage.getItem(LOCAL_STORAGE_APP_MODE_KEY);

    return appMode || AppMode.BUSINESS;
  }

  static setAppMode(value: AppMode): void {
    this.storage.setItem(LOCAL_STORAGE_APP_MODE_KEY, value.toString());
  }

  static removeAppMode(): void {
    this.storage.removeItem(LOCAL_STORAGE_APP_MODE_KEY);
  }
}

export default AppModeClientStore;
